import React,{ useState,useEffect } from "react"
import Switch from '@material-ui/core/Switch';
import Hidden from '@material-ui/core/Hidden';

const Animationbtns = {

   textAlign: "center",marginTop: "30px",position: "relative",marginBottom: "14px",marginRight: "41px"


}

const AnimationbtnsMob = {
   textAlign: "center",marginTop: "25px",position: "relative",marginBottom: "14px"

}

const AnimationBtn = (props) => {

   // const [value, setValue] = useState("Off");

   // window.localStorage.setItem('Animation', 'on');
   useEffect(() => {
      //window.localStorage.setItem('Animation', 'on');
      // document.getElementById("switchValue").checked = 'true';

      // // setValue("On");
      // document.getElementsByClassName('onOff')[0].style.left = "-17px";
   },[]);




   return (
      <>

         <div id="animation" style={Animationbtns}>
         <span > {window.finalLangues.animations}: </span>
            {/* <Switch id="switchValue" onChange={displayName} name="checkedA" color="primary"/><span className = 'onOff'>{value}</span> */}
            <label className="switch" tabIndex="1" id="animswtich" onKeyPress={props.forKeypress} >
               <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" onChange={props.onchange} type="checkbox" />
               <span className="tabIndexStyle slider round"></span>
               <span className="onOff"></span>
            </label>  
         </div>


      </>
   )
}

export default AnimationBtn;